import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  background-color: #fff;
  flex: 1;
  height: 100%;
  width: calc(100% - 165px);
  top: 0;
  z-index: 1;
  padding: 10px 0;

  ${mediaMaxWidth.phone`
    width: 100%;
    left: 0;
    top: 165px;
    height: 250px;
  `}
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 6px;
  right: 15px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.phone`
    background-color: #fff;
    top: -165px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 5px;
  `}
`;

export const Form = styled.form`
  width: 280px;

  span {
    font-size: 0.95em;
    font-weight: 700;
  }

  svg {
    margin-right: 10px;
  }

  ${mediaMaxWidth.tablet`
    svg {
      display: none;
    }
  `}

  ${mediaMaxWidth.phone`
    width: 220px;
    margin: 0 auto;

    svg {
      display: inline-block;
    }
  `}
`;

export const TextInput = styled.input`
  font-size: 0.95em;
  width: 180px;
  width: ${(props) => props.firstName && "130px"};
  width: ${(props) => props.lastName && "130px"};
  width: ${(props) => props.yearsExperience && "90px"};
  width: ${(props) => props.contact && "240px"};
  margin: 0 10px 8px 0;
  margin: ${(props) => props.yearsExperience && "0 7px 8px 0"};

  border-width: 1px;
  border-style: solid;
  border-color: rgb(231, 231, 231);
  border-image: initial;
  border-radius: 4px;
  padding: 2px 5px;

  &:focus {
    box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
      rgba(233, 102, 163, 0.6) 0px 0px 8px;
    border-color: rgb(121, 217, 217);
    outline: none;
  }

  ${mediaMaxWidth.tablet`
    width: ${(props) => props.contact && "calc(100vw - 310px)"};
  `}

  ${mediaMaxWidth.phone`
    width: 220px;
    width: ${(props) => props.firstName && "220px"};
    width: ${(props) => props.lastName && "220px"};
    width: ${(props) => props.yearsExperience && "120px"};
    width: ${(props) => props.contact && "194px"};
    margin: 0 0 8px 0;
    margin: ${(props) => props.yearsExperience && "0 10px 8px 0"};
  `}
`;

export const DisabledInputWrapper = styled.div`
  display: flex;
  margin-bottom: 3px;

  svg {
    margin-top: 3px;
  }
`;

export const DisabledInput = styled.div`
  margin-bottom: 5px;
  margin-left: 5px;
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.phone`
    width: 215px;
  `}
`;

export const SaveButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-weight: bold;
  color: #fff !important;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 85px;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
  }
`;

export const ToggleSection = styled.div`
  text-decoration: underline;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 55px;
  font-size: 0.95em;
  z-index: 2;
  width: 80px;
  text-align: right;

  &:hover {
    color: #79D9D9;
  }

  ${mediaMaxWidth.phone`
    left: 15px;
    bottom: 12px;
    text-align: left;
  `}
`;

export const EditContact = styled.div`
  display: flex;
  position: absolute;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  padding: 10px 0;
`;
